export default __webpack_public_path__ + "static/media/delete.da69e146.svg";